import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { dateFormat } from '../../../Utils/formatDate';
import moment from 'moment';
import { message } from 'antd';
import { apiCall } from '../../../API/RestApi';


export const exportLoanExcel = async (exportRange, token) => {
    if (exportRange.length < 2) {
        return message.warning("Please select start and end dates");
    }

    const [startDate, endDate] = exportRange;

    try {
        const res = await apiCall({
            method: 'GET',
            url: `/loan-requests?nopage=true&startDate=${startDate.format("YYYY-MM-DD")}&endDate=${endDate.format("YYYY-MM-DD")}`,
            data: {
                headers: { Authorization: 'Bearer ' + token },
            },
        });

        if (res.status !== 'success') {
            return message.error(res.message || "Failed to fetch data");
        }

        const data = res.data.data;
        if (!data || data.length === 0) {
            return message.info("No data found in selected range");
        }

        // Lanjut ke export logic
        const headers = [
            "No", "Request Date", "Start Date", "End Date", "Status", "Purpose",
            "User Name", "User Code", "User Position",
            "License Plate", "Brand", "Model", "Type", "Color", "Year",
            "Approver Name", "Approver Position",
            "Feedback Satisfaction", "Feedback Rating", "Feedback Comments"
        ];

        const rows = data.map((item, index) => ({
            No: index + 1,
            Request_Date: dateFormat(item.request_date),
            Start_Date: moment(item.start_date).format('YYYY-MM-DD'),
            End_Date: moment(item.end_date).format('YYYY-MM-DD'),
            Status: item.approval_status,
            Purpose: item.purpose,
            User_Name: item.user_request?.name || '-',
            User_Code: item.user_request?.users_code || '-',
            User_Position: item.user_request?.position?.name || '-',
            License_Plate: item.vehicle?.license_plate || '-',
            Brand: item.vehicle?.brand || '-',
            Model: item.vehicle?.model || '-',
            Type: item.vehicle?.type || '-',
            Color: item.vehicle?.color || '-',
            Year: item.vehicle?.year || '-',
            Approver_Name: item.user_approval?.name || '',
            Approver_Position: item.user_approval?.position?.name || '',
            Feedback_Satisfaction: item.loan_feedback?.satisfaction || '',
            Feedback_Rating: item.loan_feedback?.rating || '',
            Feedback_Comments: item.loan_feedback?.comments || '',
        }));

        const wsData = [
            [{ v: "Loan Request Report", s: { font: { bold: true, sz: 14 }, alignment: { horizontal: "center" } } }],
            [{
                v: `Date Range: ${startDate.format('YYYY-MM-DD')} to ${endDate.format('YYYY-MM-DD')}`,
                s: { font: { italic: true }, alignment: { horizontal: "center" } }
            }],
            headers.map(h => ({
                v: h,
                s: {
                    font: { bold: true },
                    border: {
                        top: { style: 'thin', color: { rgb: "000000" } },
                        bottom: { style: 'thin', color: { rgb: "000000" } },
                        left: { style: 'thin', color: { rgb: "000000" } },
                        right: { style: 'thin', color: { rgb: "000000" } },
                    },
                    alignment: { horizontal: "center", vertical: "center" }
                }
            })),
            ...rows.map(obj =>
                headers.map(h => ({
                    v: obj[h.replace(/ /g, "_")],
                    s: {
                        border: {
                            top: { style: 'thin', color: { rgb: "d0d0d0" } },
                            bottom: { style: 'thin', color: { rgb: "d0d0d0" } },
                            left: { style: 'thin', color: { rgb: "d0d0d0" } },
                            right: { style: 'thin', color: { rgb: "d0d0d0" } },
                        },
                        alignment: { horizontal: "left", vertical: "top", wrapText: true }
                    }
                }))
            )
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(wsData);

        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } }
        ];

        const maxColumnLengths = headers.map((_, colIdx) =>
            Math.max(
                wsData[2][colIdx]?.v?.toString()?.length || 10,
                ...rows.map(row => (row[headers[colIdx].replace(/ /g, "_")]?.toString()?.length || 0))
            )
        );

        worksheet['!cols'] = maxColumnLengths.map(len => ({ wch: Math.min(len + 5, 60) }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Data");

        const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        saveAs(blob, `LoanRequests_${startDate.format("YYYYMMDD")}_${endDate.format("YYYYMMDD")}.xlsx`);
    } catch (error) {
        console.error(error);
        message.error("Failed to export data");
    }
};
